import React, { useContext } from 'react';
import classes from './Home.module.css';
import { Link } from 'react-scroll';
import { ThemeContext } from '../../ThemeProvider';
import { motion } from 'framer-motion';

const Home = () => {
  const { dark } = useContext(ThemeContext);

  const animateFrom = { opacity: 0, y: 40 };
  const animateTo = { opacity: 1, y: 0 };

  return (
    <section className={classes.home}>
      <motion.p
        initial={animateFrom}
        animate={animateTo}
        transition={{ delay: 0.7, duration: 0.5, type: 'tween' }}
        className={dark ? `${classes.line1} ${classes.line1__dark}` : classes.line1}
      >
        Hi, &nbsp; my &nbsp; name &nbsp; is
      </motion.p>
      <motion.h1
        initial={animateFrom}
        animate={animateTo}
        transition={{ delay: 0.9, duration: 0.5, type: 'tween' }}
        className={dark ? `${classes.home__focusLine1} ${classes.home__focusLine1__dark}` : classes.home__focusLine1}
      >
        Partha Roy.
      </motion.h1>
      <motion.h1
        initial={animateFrom}
        animate={animateTo}
        transition={{ delay: 1.1, duration: 0.5, type: 'tween' }}
        className={dark ? `${classes.home__focusLine2} ${classes.home__focusLine2__dark}` : classes.home__focusLine2}
      >
        I build Apps.
      </motion.h1>
      <motion.p
        initial={animateFrom}
        animate={animateTo}
        transition={{ delay: 1.3, duration: 0.5, type: 'tween' }}
        className={dark ? `${classes.home__intro} ${classes.home__intro__dark}` : classes.home__intro}
      >
        I am a Frontend Heavy Fullstack Engineer. Based out of Kolkata. Love to build exceptional, high quality web and
        mobile apps.
        <span
          className={dark ? `${classes.highlight__Line} ${classes.highlight__Line__dark}` : classes.highlight__Line}
        >
          &nbsp; Currently looking for a good opportunity.
        </span>
      </motion.p>
      <motion.div initial={animateFrom} animate={animateTo} transition={{ delay: 1.5, duration: 0.5, type: 'tween' }}>
        <Link
          to='contact'
          smooth={true}
          className={dark ? `${classes.getInTouch} ${classes.getInTouch__dark}` : classes.getInTouch}
        >
          Get In Touch
        </Link>
      </motion.div>
    </section>
  );
};

export default Home;
